// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3FB6p","Label":"Checkbox_Label__3qgdY","InputElement":"Checkbox_InputElement__2eDwT","Invalid":"Checkbox_Invalid__1fZS5"};